import { useState } from 'react'
import { ReceiptStep, PaymentMethods } from 'components/TreatmentPlan/Review'
import StripeElement from 'components/StripeElement'

const PaymentStep = ({ treatmentPlanId, onNext }) => {
  const [paymentState, setPaymentState] = useState('payment_method')
  const [selectedMethod, setSelectedMethod] = useState(null)

  let { future_schedule, pay_today, title, amount_type, percentage } = selectedMethod || {}
  let _resource = { resource_type: 'TreatmentPlan', resource_id: treatmentPlanId }

  return (
    <div>
      {selectedMethod && paymentState === "make_payment" && (
        <div className="w-full lg:max-w-[84%] mx-auto pt-5 pb-0">
          <div className="rounded-xl border border-secondary-200 bg-white overflow-hidden">
            <div className="px-5 py-4 border-b border-secondary-100">
              <h2 className="text-sm font-bold text-secondary-900">
                {amount_type === "percentage" ? `${percentage.toFixed(0)}% ${title}` : title}
              </h2>
            </div>

            <div className="flex divide-x divide-secondary-100">
              <div className="flex-1 px-5 py-4">
                <p className="text-[11px] text-secondary-400 mb-1.5">Pay Today</p>
                <p className="text-2xl font-extrabold text-blue-600">${Number(pay_today).toFixed(2)}</p>
              </div>

              <div className="flex-1 px-5 py-4">
                <p className="text-[11px] text-secondary-400 mb-1.5">Future Payments</p>
                <p className="text-sm font-semibold text-secondary-700 leading-snug line-clamp-2">{future_schedule}</p>
              </div>
            </div>
          </div>
        </div>
      )}

      {
        paymentState == "payment_method" ? <PaymentMethods treatmentPlanId={treatmentPlanId} setPaymentState={setPaymentState} setSelectedMethod={setSelectedMethod} />
          : paymentState == "make_payment" ? <StripeElement resource={_resource} onSuccess={() => setPaymentState('send_receipt')} />
            : paymentState == "send_receipt" ? <ReceiptStep onNext={onNext} treatmentPlanId={treatmentPlanId} />
              : null
      }
    </div>
  )
}

export default PaymentStep;
